import { Theme, Components } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

/* eslint-disable import/prefer-default-export */
export const dataDisplayCustomizations: Components<Theme> = {
  MuiDataGrid: {
    styleOverrides: {
      root: ({theme}) => ({
        borderWidth: '0',
        borderRadius: 6,
        '--DataGrid-rowBorderColor': theme.vars?.palette.divider,
        '--unstable_DataGrid-headWeight': '600',
        
      }),
      cell: {
        alignItems: 'center',
        display: 'flex',
        padding: '5px 10px',
        lineHeight: '1.5',
        height: 'auto !important',
        // color: THEME_COLORS.gray900,
        '&:focus, &:focus-within': {
          outline: 'none',
        },
      },
      columnHeader: {
        '&:focus-within': {
          outline: 'none',
        },
      },
      toolbar: ({theme}) => ({
        padding: 0,
        marginBottom: 15,
        justifyContent: 'space-between',
        border: 'none',

        '& .MuiFormControl-root': {
          background: theme.vars?.palette.background.default,
        }
      }),
      main: ({theme}) => ({
        background: theme.vars?.palette.background.default,
        borderRadius: 6,
        boxShadow: theme.vars?.palette.baseShadow,
        border: '1px solid var(--DataGrid-rowBorderColor)',
      }),
      row: {
        'minHeight': '52px !important',
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        boxShadow: theme.vars?.palette.baseShadow,
        borderRadius: 8,
      }),
    },
  },
};
